import { jsx, jsxs } from "react/jsx-runtime";
import {
  H2,
  Paragraph,
  Separator,
  Square,
  XStack,
  YStack,
  getTokens,
  getVariableValue
} from "tamagui";
const colorGroups = ["orange", "yellow", "green", "blue", "purple", "pink", "red"];
function ColorsDemo() {
  const colors = getTokens({ prefixed: false }).color;
  const [colorsLight, colorsDark] = [getColors(colors), getColors(colors, true)];
  return /* @__PURE__ */ jsxs(YStack, { marginTop: "$4", space: "$8", children: [
    /* @__PURE__ */ jsx(ColorsRow, { title: "Light", colors: colorsLight }),
    /* @__PURE__ */ jsx(Separator, {}),
    /* @__PURE__ */ jsx(ColorsRow, { title: "Dark", colors: colorsDark })
  ] });
}
function ColorsRow({ title, colors }) {
  return /* @__PURE__ */ jsxs(YStack, { space: true, $sm: { space: "$2" }, children: [
    /* @__PURE__ */ jsx(H2, { size: "$2", children: title }),
    /* @__PURE__ */ jsxs(XStack, { space: true, alignSelf: "center", children: [
      /* @__PURE__ */ jsxs(YStack, { space: true, $sm: { space: "$2" }, alignSelf: "center", children: [
        colors.map((group, index) => {
          return /* @__PURE__ */ jsx(XStack, { space: "$2", children: group.map((color) => {
            return /* @__PURE__ */ jsx(
              Square,
              {
                borderRadius: "$2",
                size: "$4",
                height: "$4",
                borderWidth: 1,
                backgroundColor: getVariableValue(color),
                borderColor: "$color7",
                $sm: {
                  size: "$2"
                },
                $xs: {
                  size: "$1"
                }
              },
              `${color.key}${index}`
            );
          }) }, index);
        }),
        /* @__PURE__ */ jsx(XStack, { space: "$2", alignSelf: "center", children: new Array(13).fill(0).slice(1).map((_, index) => {
          return /* @__PURE__ */ jsx(
            Paragraph,
            {
              color: "$color10",
              textAlign: "center",
              width: "$4",
              $sm: {
                width: "$2"
              },
              $xs: {
                width: "$1"
              },
              children: index
            },
            index
          );
        }) })
      ] }),
      /* @__PURE__ */ jsx(YStack, { space: "$4", marginTop: "$2", children: colorGroups.map((name) => /* @__PURE__ */ jsx(
        Paragraph,
        {
          theme: name,
          color: "$color10",
          height: "$4",
          rotate: "-10deg",
          $sm: {
            height: "$2"
          },
          $xs: {
            height: "$1"
          },
          children: name
        },
        name
      )) })
    ] })
  ] });
}
function getColors(colors, dark = false) {
  return colorGroups.map((group) => {
    return Object.keys(colors).filter(
      (color) => color.startsWith(group) && (dark ? color.endsWith("Dark") : !color.endsWith("Dark"))
    ).map((key) => colors[key]);
  });
}
export {
  ColorsDemo
};
//# sourceMappingURL=ColorsDemo.js.map
